<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Add Advisory Board</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/advisoryboard" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="createAdvBoard" v-if="advisoryBoard">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-12">
                                <fg-input type="text"
                                          v-model="advisoryBoard.key"
                                          label="Member Name"
                                          placeholder="Enter Member Name"
                                          v-validate="rules.key"
                                          data-vv-name="key"
                                          cus-name="key"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                          <div class="col-md-12">
                            <fg-input type="text"
                                      v-model="advisoryBoard.value"
                                      label="Position or role of memeber"
                                      placeholder="Enter Member Position or role"
                                      data-vv-name="value"
                                      v-validate="rules.value"
                                      cus-name="value"
                                      :has-errors="errors"
                                      :is-fields="fields"
                                      >
                            </fg-input>
                          </div>


                        </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Create Advisory Board Member
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'CreateAdvisoryBoard',
        created (){
    },
    data () {
        return {
            advisoryBoard: {
              key: '',
              value: '',
              active: 1
            },
          corps: [],
            active: 1,
            status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
            rules: {
              key: {required : true},
              value: {required : true},
              active: {required: true}
            },
            message: {
                error: false,
                text: ''
            }
        }
    },
    methods: {
        createAdvBoard () {
          console.log("[inside createAdvisoryBoard.vue -> createAdvBoard] this.advisoryBoard : ", this.advisoryBoard);
          this.$validator.validateAll().then((result) => {
            if(result){
              this.$store.dispatch('ADD_ADVISORY_BOARD', this.advisoryBoard)
                .then((res) => {
                  console.log("ADD_ADVISORY_BOARD res : ", res);
                  if (res) this.showPopup('Success!', 'NEW ADVISORY BOARD MEMBER is successfully created', 'success', ()=>this.$router.push('/admin/advisoryboard'))
                  else this.showPopup('Error!', 'Unable to process.', 'error')
                })
                .catch(err => {
                  this.showPopup('Error!', 'some thing happen wrong', 'error')
                  console.log("ADD_ADVISORY_BOARD API error : ", err);
                })
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    created() {
      // this.fetchCorporations();
    },

    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Podcast/CreateAdvisoryBoard.vue